<div class="dialog-container">
  <h2 mat-dialog-title class="font-text">Seleccionar la categoría destino</h2>
  <p class="font-text">Moviendo {{poisToMove.length}} pois</p>

  <mat-dialog-content class="mat-typography">
    <app-select (idSelected)="handleSelected($event)"></app-select>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close="false" class="font-text btn-cancel">Cancelar</button>
    <button mat-button mat-dialog-close="true" cdkFocusInitial class="font-text btn-move" (click)="movePois()">Mover</button>
  </mat-dialog-actions>
</div>